var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrCode"},[_c('div',{staticClass:"div_code"},[_c('h3',[_vm._v(_vm._s(_vm.$formatName(_vm.name)))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"30px"}},[_vm._v("用户号："+_vm._s(_vm.code))]),_vm._v(" "),_c('vue-qr',{attrs:{"text":_vm.code,"size":260}}),_vm._v(" "),_c('p',{staticClass:"user_code"},[_vm._v(_vm._s(_vm.address))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e5a6fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/fzxx/qRcode.vue
// module id = null
// module chunks = 